import { useAudioControls } from "../hooks/use-audio-controls";

const VolumeControl: React.FC = () => {
  const { volume, handleVolumeChange } = useAudioControls();

  return (
    <div className="items-center gap-1 hidden sm:flex">
      <span className="text-xs text-background min-w-[26px] text-right">{Math.round(volume * 100)}%</span>
      <input
        type="range"
        dir="ltr"
        min={0}
        max={1}
        step={0.01}
        value={volume}
        onChange={(event) => handleVolumeChange(Number(event.target.value))}
        className="h-1 w-24 cursor-pointer rounded-full bg-default-600 accent-primary"
      />
    </div>
  );
};

export default VolumeControl;
